var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 132,
    width: 132,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_1",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#525252",
    id: "svg_2",
    fill: "#F8F8F8",
    strokeWidth: 0.5,
    d: "m92.18536,102.25942c16.64255,0 31.28833,-14.64578 31.28833,-32.71053s-14.64578,-32.71053 -31.28833,-32.71053c-19.48694,0 -34.13272,14.64578 -34.13272,32.71053s14.64578,32.71053 34.13272,32.71053z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#808080",
    strokeWidth: 0.652,
    id: "Shape",
    d: "m100.71854,39.68276l-5.68879,5.68879l-2.84439,2.84439m24.03513,17.33658s-4.32917,-3.81433 -8.78064,-6.09269c-4.44863,-2.27836 -10.86843,-2.90697 -10.86843,-2.90697m-11.22682,6.19793s-0.67128,5.25075 0,9.56001l2.97239,9.55432m11.32069,6.58193s6.3174,0.38115 11.13865,-3.10608c4.82978,-3.47585 7.17925,-8.28856 7.17925,-8.28856m-56.30762,-10.25119s1.87161,-4.43157 5.95332,-7.21623c4.08455,-2.78182 9.85298,-3.68633 9.85298,-3.68633m-5.7855,-13.18092c4.71885,-1.24016 9.17033,5.98176 9.17033,5.98176m-17.0749,29.7552s2.84439,5.29342 7.08823,7.51204c4.24099,2.21294 9.4889,2.50022 9.4889,2.50022m14.35281,8.59576l2.09916,5.06302m-11.65917,-5.54941l-2.22716,5.68879"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_3",
    fill: "#1A1A1A",
    d: "m97.87414,56.96245l-11.40033,8.31985l-11.35482,-8.50189l4.74729,-11.32638l14.13664,-0.07964l3.87406,11.5909l-0.00284,-0.00284zm-1.03536,42.45258l3.87975,-11.5909l-11.40033,-8.31985l-11.35482,8.50189l4.74729,11.32353l14.1281,0.08533zm-38.28554,-34.90356l5.41573,0l2.41205,16.52308l-4.17557,4.55956s-2.44902,-2.59693 -3.71193,-9.50596c-1.02398,-5.59208 0.05973,-11.57668 0.05973,-11.57668zm62.05045,-7.01427l-8.83469,7.19063l2.72208,15.01271l7.97852,-2.31249s1.20602,-5.00044 0.54612,-10.88834c-0.5063,-4.37752 -2.41489,-8.99966 -2.41489,-8.99966l0.00284,-0.00284zm-22.72955,-14.97004l11.37757,-1.64406s-1.75784,-1.1406 -5.69163,-2.54858c-3.92242,-1.41082 -5.68594,-1.49615 -5.68594,-1.49615l0,5.68879z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_46"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    transform: "matrix(2.9920734620119966,0,0,2.9920734620119966,146.02816067685325,152.17595897228097) ",
    id: "svg_7",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_8",
    d: "m-44.87622,-50.84801s10.859,4.893 17.233,7.871c6.372,2.979 9.675,4.948 13.594,6.928c3.32,1.677 6.878,2.359 6.798,6.865c-0.078,4.41 -1.08,5.173 -3.594,7.515c-4.038,3.764 -7.341,5.492 -10.449,7.258c-3.363,1.909 -6.982,6.872 -6.982,6.872"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_9",
    d: "m-25.03722,-41.48901s-4.272,-1.886 -8.946,-3.161c-5.2,-1.419 -10.927,-4.196 -10.927,-4.196"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_10",
    d: "m-38.66622,-48.03201s1.089,2.117 0.563,2.292c-0.526,0.176 -2.605,-1.416 -3.305,-2.342c-0.701,-0.925 -0.447,-1.712 -0.447,-1.712"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_11",
    d: "m-42.93022,-47.81201l0.948,3.018"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_12",
    d: "m-44.96522,-45.84801l9.928,4.179"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_13",
    d: "m-37.96622,-45.68101c0.008,-0.468 1.469,3.169 3.703,4.731c2.234,1.563 6.562,4.182 6.562,4.182l3.289,4.737l6.283,1.594l4.423,-2.704s6.748,-0.186 6.466,2.899c-0.283,3.085 -5.66,6.092 -7.399,7.297c-4.936,3.419 -6.799,8.529 -6.799,8.529"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_14",
    d: "m-13.43422,-19.09901l-0.312,-3.93l-5.203,-1.347l-6.424,2.801l-3.157,5.442s-2.91,0.948 -5.746,3.428c-2.838,2.48 -5.368,4.964 -5.368,4.964"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_15",
    d: "m-13.18122,-33.27401s-5,-1.766 -6.632,-2.603c-1.635,-0.837 -3.42,-1.474 -3.42,-1.474s-3.068,-1.143 -4.269,-2.374c-1.2,-1.231 -3.5,-3.871 -3.5,-3.871"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_16",
    d: "m-30.01922,-42.57901l4.223,9.079l3.423,-3.834s-4.088,-4.684 -3.27,-4.67c0.816,0.015 12.463,8.73 12.463,8.73"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_17",
    d: "m-34.98322,-44.66901l2.91,5.054"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_18",
    d: "m-18.38222,-30.36701s0.202,0.625 0.079,2.702c-0.122,2.078 -1.057,4.282 -1.057,4.282"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_19",
    d: "m-19.94322,-17.93201l-5.177,2.733s-0.154,1.383 -2.436,2.673l-4.845,3.914l-1.227,-0.022l3.107,-4.143c0.656,-0.567 3.74,-2.525 3.74,-2.525l3.166,-4.735l6.215,-1.067s-1.687,-3.303 -1.49,-3.27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_20",
    d: "m-26.53922,-13.45501l-2,0.012"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_21",
    d: "m-19.44922,-18.38201l-5,-0.089"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_22",
    d: "m-18.28722,-27.36401s-1.874,0.331 -4.985,0.715c-3.112,0.384 -5.401,-0.096 -5.401,-0.096l-3.379,-5.096s-1.781,-1.003 -1.918,-1.065c-0.139,-0.061 -2.205,-0.274 -2.205,-0.274l-4.737,-5.329l-4.101,-4.617l0.648,-0.711l7.825,4.774s2.08,1.165 3.117,2.297c1.037,1.132 1.718,2.14 1.718,2.14l4.493,0.842l3.39,2.125l-4.484,2.368l-3.227,-0.721l-5.202,1.977l-1.126,-2.379l-3.123,-0.07l-4.166,-4.866l3.672,-3.803"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_23",
    d: "m-36.18022,-33.68601l-2.054,2.965"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_24",
    d: "m-45.14422,-35.84801l2.334,7.19l2.922,5.907l3.296,0.06l1.825,-2.367l3.176,0.408l2.976,-2.579l0.367,-2.554"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_25",
    d: "m-39.39522,-21.74001l1.905,-5.968l2.139,3.603"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_26",
    d: "m-41.23422,-30.77701l-1.732,2.299l-2.321,0.629"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_27",
    d: "m-46.45722,-18.38801l2.411,-0.262l1.638,5.858l1.981,0.035l3.93,-3.245s3.412,-0.682 4.639,-2.125l5.451,-2.703l0.084,-4.677l-8.961,5.777l-7.195,6.695l3.171,-9.181"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_28",
    d: "m-39.37622,-22.74001l-5.09,4.911"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_29",
    d: "m-45.61022,-9.84801l4.072,-3.928"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_30",
    d: "m-46.59222,-10.86701l3.982,1.073"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_31",
    d: "m-44.64622,-7.83001l5.43,-5.905l5.674,0.366"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_32",
    d: "m-34.55722,-12.65101l3.111,-6.159l1.073,-4.123l-1.669,-1.678"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_33",
    d: "m-36.62822,-8.68701l3.913,-3.938l1.195,-1.973"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_34",
    d: "m-32.55822,-12.56001l3,0.098"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_35",
    d: "m-29.50322,-15.52801l3.984,1.003"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_36",
    d: "m-26.39522,-21.50701l2.965,2.053"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_37",
    d: "m-34.34222,-24.65101l0.876,7.018"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_38",
    d: "m-35.34122,-24.66801l-4.107,5.928l2.947,3.054"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_39",
    d: "m-29.30622,-26.56101l-0.054,3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_40",
    d: "m-32.21522,-31.61501l0.637,-2.99"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_41",
    d: "m-34.19722,-32.65101l-1.892,-6.036l-5.736,-1.103l-4.253,0.26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_42",
    d: "m-42.07222,-39.79401l1.038,-2.073l4.016,-0.837"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_43",
    d: "m-24.50322,-15.47301l-1.784,4.971l-4.306,-0.078l5.071,-3.902"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_44",
    d: "m-11.32422,-25.23901c1.711,0.484 0.666,2.012 0.648,3.013"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_45",
    d: "m-32.55622,-12.61501l3.982,1.072"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScore);
export default __webpack_public_path__ + "static/media/score.e89f1aec60c4b0365ea57037b4a86d78.svg";
export { ForwardRef as ReactComponent };